// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/rescueTeam";
const RESOURCE_NAME2 = "/admin";
export default {
  getTeams( Page= 1, PageSize = 15) {
    return axios.get(`${RESOURCE_NAME}/getTeams`, {
      params: { Page: Page, PageSize: PageSize },
    });
  },
  getAdmins( teamId="") {
    return axios.get(`${RESOURCE_NAME}/getAdmins`, {
      params: { teamId:teamId },
    });
  },
  addMembers(body) {
    return axios.post(`${RESOURCE_NAME}/addMember`, body);
  },
  createTeam(body) {
    return axios.post(`${RESOURCE_NAME}/create`, body);
  },
  deleteMember(body) {
    return axios.put(`${RESOURCE_NAME}/deleteMember`, body);
  },
};
